import React, { useRef, useState, useEffect, useCallback } from "react";
import { useDarkMode } from "../store/editorStoreSelectors";
import ToolbarRow1 from "./toolbar/ToolbarRow1";
import { makeToolbarStyles } from "./toolbar/toolbarStyles";

/**
 * The global toolbar: page layout, size, style, view toggles, export, undo.
 * Controls for whatever is selected live in the floating SelectionPalette.
 */
const TopMenuBar = ({
  onChangeLayoutTemplate,
  onDownload,
  onClearSavedData,
  onExportJSON,
  onImportJSON,
  onCustomGrid,
  onGutterSizeChange,
  onPageSizeChange,
  onStoryboardChange,
}) => {
  const darkMode = useDarkMode();
  const barRef = useRef(null);

  // Dropdown panel state — one panel open at a time
  const [openPanel, setOpenPanel] = useState(null);
  const togglePanel = useCallback((name) => setOpenPanel((prev) => (prev === name ? null : name)), []);

  // Close panel on click outside
  useEffect(() => {
    if (!openPanel) return undefined;
    const handleClick = (e) => {
      if (barRef.current && !barRef.current.contains(e.target)) setOpenPanel(null);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [openPanel]);

  // Clicking toolbar buttons shouldn't steal focus from the page
  const handleMenuMouseDown = (event) => {
    const isButton = event.target.closest("button");
    if (isButton && !isButton.closest('[data-allow-focus-transfer="true"]')) event.preventDefault();
  };

  const { barStyle, rowStyle, panelStyle } = makeToolbarStyles(darkMode);

  return (
    <div ref={barRef} data-striply-toolbar style={barStyle} onMouseDownCapture={handleMenuMouseDown}>
      <ToolbarRow1
        onChangeLayoutTemplate={onChangeLayoutTemplate}
        onDownload={onDownload}
        onClearSavedData={onClearSavedData}
        onExportJSON={onExportJSON}
        onImportJSON={onImportJSON}
        onCustomGrid={onCustomGrid}
        onGutterSizeChange={onGutterSizeChange}
        onPageSizeChange={onPageSizeChange}
        onStoryboardChange={onStoryboardChange}
        effectivePanelStyle={panelStyle}
        openPanel={openPanel}
        togglePanel={togglePanel}
        rowStyle={rowStyle}
      />
    </div>
  );
};

export default React.memo(TopMenuBar);
